/**
 * Gift Card Character Counter & Validation
 * Added to a separate file so that it doesn't bloat the product form and conditionally loads only if the gift card form is present
 */
document.addEventListener('DOMContentLoaded', function() {
  // Show counters after 100ms to prevent customer seeing counters jumping positions on the DOM load
  setTimeout(() => {
    document.querySelectorAll('.Form__Counter').forEach(counter => {
      counter.classList.remove('hidden');
    });
  }, 100);

  // Validate gift card required fields before AJAX add-to-cart
  // The add-to-cart button is a React component, so native DOM click listeners
  // don't intercept it. Instead, we wrap window.fetch to block /cart/add.js
  // requests when required gift card fields are empty.
  if (document.getElementById('product-giftcard-template')) {
    var origFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      if (url && url.toString().indexOf('/cart/add') !== -1) {
        var toName = document.getElementById('gift-card-to-name');
        var toEmail = document.getElementById('gift-card-to-email');
        var fromName = document.getElementById('gift-card-from-name');
        var message = document.getElementById('gift-card-message');
        var errorEl = document.getElementById('gift-card-error');

        if (toName && toEmail && fromName && message) {
          var isEmpty = toName.value === '' || toEmail.value === '' || fromName.value === '' || message.value === '';
          if (isEmpty) {
            if (errorEl) errorEl.style.cssText = 'display:block';
            setTimeout(function() {
              var btn = document.querySelector('[data-action="add-to-cart"]');
              if (btn) {
                btn.removeAttribute('disabled');
                btn.innerHTML = '<span class="w-full">Add to cart</span>';
              }
              // Remove any error element the theme may have inserted
              var formError = document.querySelector('.ProductForm__Error');
              if (formError) formError.remove();
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
            }, 200);
            return Promise.resolve(new Response(JSON.stringify({ description: '' }), {
              status: 422,
              headers: { 'Content-Type': 'application/json' }
            }));
          } else {
            if (errorEl) errorEl.style.cssText = 'display:none';
          }
        }
      }
      return origFetch.apply(this, arguments);
    };
  }

  if (document.getElementById('gift-card-to-name')) {
    const giftCardFields = Array.from(document.querySelectorAll('[id^="gift-card-"]')).map(el => el.id);

    giftCardFields.forEach(fieldId => {
      // Get all required elements and make sure they exist
      const field = document.getElementById(fieldId);
      if (!field) {
        console.warn(`Gift card field ${fieldId} not found`);
        return;
      }

      const counter = document.getElementById(fieldId + '-counter');
      if (!counter) {
        console.warn(`Counter for ${fieldId} not found`);
        return;
      }

      const formItem = field.closest('.Form__Item');
      if (!formItem) {
        console.warn(`Form item wrapper for ${fieldId} not found`);
        return;
      }

      const counterWrapper = counter.parentElement?.parentElement;
      if (!counterWrapper) {
        console.warn(`Counter wrapper for ${fieldId} not found`);
        return;
      }

      const errorDisplay = formItem.querySelector('.gift-card-counter-error');
      if (!errorDisplay) {
        console.warn(`Error display for ${fieldId} not found`);
        return;
      }

      // Get the character limit from the data attribute
      const limit = parseInt(field.getAttribute('data-char-limit'), 10);
      if (isNaN(limit)) {
        console.warn(`No valid character limit found for ${fieldId}`);
        return;
      }

      // Add event listener to the field
      field.addEventListener('input', function() {
        let value = this.value;
        if (value.length > limit) {
          this.value = value.substring(0, limit);
          value = this.value;
        }
        const length = value.length;
        counter.textContent = length;

        if (length >= limit) {
          errorDisplay.classList.remove('opacity-0', 'pointer-events-none');
          errorDisplay.classList.add('opacity-100', 'pointer-events-auto');
          counterWrapper.classList.add('limit-reached');
        } else {
          errorDisplay.classList.add('opacity-0', 'pointer-events-none');
          errorDisplay.classList.remove('opacity-100', 'pointer-events-auto');
          counterWrapper.classList.remove('limit-reached');
        }
      });
      
      // Initialize counter
      counter.textContent = field.value.length;
    });
  }
});